import React from 'react';

import { DirectorySettingsModalProvider } from './DirectorySettingsModalProvider';
import { AddEditAdultModal } from './modals/AddEditAdultModal';
import { AddEditChildModal } from './modals/AddEditChild/AddEditChildModal';
import { AddEditFamilyModal } from './modals/AddEditFamilyModal';
import { CauseDirectorySettingsModal } from './modals/CauseDirectorySettings/CauseDirectorySettingsModal';
import { DeleteFamilyModal } from './modals/DeleteFamilyModal';
import { DirectorySettingsModal } from './modals/DirectorySettingsModal';
import { ManageFamiliesModal } from './modals/ManageFamiliesModal';
import { ManageFamilyMembersModal } from './modals/ManageFamilyMembersModal';
import { RemoveAdultModal } from './modals/RemoveAdultModal';
import { RemoveChildModal } from './modals/RemoveChildModal';

const DirectorySettingsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <DirectorySettingsModalProvider meta={{}}>
      {children}
      <DirectorySettingsModal />
      <CauseDirectorySettingsModal />
      <ManageFamiliesModal />
      <ManageFamilyMembersModal />
      <AddEditFamilyModal />
      <DeleteFamilyModal />
      <AddEditAdultModal />
      <RemoveAdultModal />
      <AddEditChildModal />
      <RemoveChildModal />
    </DirectorySettingsModalProvider>
  );
};

export { DirectorySettingsProvider };
